/**
 * Loading states for async operations
 */
export type LOADING_STATE = "idle" | "pending" | "fulfilled" | "rejected";

/**
 * Permission groups for user access control
 *
 * ENGINEER_LDAP_GROUP: Highest privilege — can delete sessions, manage profiles (CRUD)
 * ADMIN_LDAP_GROUP: Admin-level — can view all sessions, but cannot delete or manage profiles
 * GENERAL_USER_LDAP_GROUP: Standard user — can only view/manage their own sessions
 * AUDITOR_LDAP_GROUP: Can audit validated sessions across all sites, and is read-only on
 *   sessions that are neither theirs nor at one of their sites. Orthogonal to the levels
 *   above — an auditor is usually a general user too.
 */
export const ENGINEER_LDAP_GROUP = "workingwell-engineer";
export const ADMIN_LDAP_GROUP = "whs-data-navigator-admin";
export const GENERAL_USER_LDAP_GROUP = "whs-data-navigator-user";
export const AUDITOR_LDAP_GROUP = "whs-data-navigator-auditor";

/** Every group Navigator recognizes, which is the allowlist for simulation. Must match the service. */
export const NAVIGATOR_LDAP_GROUPS = [
  GENERAL_USER_LDAP_GROUP,
  AUDITOR_LDAP_GROUP,
  ADMIN_LDAP_GROUP,
  ENGINEER_LDAP_GROUP,
];

/** Must match SIMULATE_LDAP_GROUPS_HEADER in the service */
export const SIMULATE_LDAP_GROUPS_HEADER = "X-Simulate-Ldap-Groups";

/**
 * Local storage keys
 */
export const USER_STORAGE_KEY = "user";
export const TOKEN_STORAGE_KEY = "token";
export const ASSETS_LAST_MODIFIED_KEY = "assets-last-modified";
export const SIMULATE_LDAP_GROUPS_STORAGE_KEY = "simulate-ldap-groups";
